import React, { useState } from "react";
import { useLanderConfig } from "../commons/ConfigContext";
import { QueryParam } from "../commons/Constants";
import { getYahooAdsUri } from "./yahooFeed";

interface SearchBoxProps {
  xmlResult: Document | null;
}

export const SearchBox: React.FC<SearchBoxProps> = ({ xmlResult }) => {
  const config = useLanderConfig();
  const rootDomain = config.landerConfig.domain.rootDomain;
  const [inputText, setInputText] = useState<string>("");

  const queryParam =
    xmlResult?.getElementById("searchBox")?.getAttribute("queryParams") ?? "";

  if (
    config.landerConfig.lander.template.includes("PARK_WEB") || // dont show search for parkweb and heg
    !config.queryConfig[QueryParam.SEARCH_BOX] ||
    !queryParam
  )
    return null;

  return (
    <div id="searchbox">
      <input
        type="text"
        value={ inputText }
        onChange={ (event) => setInputText(event.target.value) }
      />
      <a
        href={ getYahooAdsUri({
          qs: queryParam,
          rootDomain,
          searchQuery: inputText,
          system: config.landerConfig.system,
          customerId: config.landerConfig.customerId,
        }) }
      >
        <button>Search Ads</button>
      </a>
    </div>
  );
};
